<template>
  <div class="card address-info mr-2">
    <div
      class="header border-bottom accordian-toggle"
      v-b-toggle.adderessSection
      @click="getaddressDetails"
    >
      <h5 class="text-primary font-weight-normal mb-0 mr-4">Address</h5>
    </div>
    <b-collapse id="adderessSection">
      <div class="body">
        <ValidationObserver v-slot="{ passes }">
          <form @submit.prevent="passes(addressDataSubmit)">
            <div class="edit-form">
              <div class="row">
                <div class="col-lg-6 col-12">
                  <ValidationProvider
                    name="addressline1"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group"
                      :class="{
                        errors: errors.length && !addressDetail.addressline1,
                        success: addressDetail.addressline1,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="addressDetail.addressline1"
                          class="form-control"
                          id="addressline1"
                          placeholder="Address Line 1*"
                        />
                        <label for="addressline1" class="control-label">
                          Address Line 1*
                        </label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !addressDetail.addressline1"
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="addressDetail.addressline1"
                        ></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <div class="form-group">
                    <span class="float-label">
                      <textarea
                        class="form-control"
                        id="addressline2"
                        v-model="addressDetail.addressline2"
                        placeholder="Address Line 2"
                      ></textarea>
                      <label for="addressline2" class="control-label">
                        Address Line 2
                      </label>
                      <div class="line"></div>
                    </span>
                  </div>
                  <div class="form-group">
                    <span class="float-label">
                      <textarea
                        class="form-control"
                        id="addressline3"
                        v-model="addressDetail.addressline3"
                        placeholder="Address Line 3"
                      ></textarea>
                      <label for="addressline3" class="control-label">
                        Address Line 3
                      </label>
                      <div class="line"></div>
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <ValidationProvider
                    name="city"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group"
                      :class="{
                        errors: errors.length && !addressDetail.city,
                        success: addressDetail.city,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="addressDetail.city"
                          class="form-control"
                          id="city"
                          placeholder="City*"
                        />
                        <label for="city" class="control-label">City*</label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !addressDetail.city"
                        ></i>
                        <i class="fa fa-check" v-if="addressDetail.city"></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    name="state"
                    :rules="stateField.required ? 'required' : ''"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group"
                      :class="{
                        errors: errors.length && !addressDetail.state,
                        success: addressDetail.state,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="addressDetail.state"
                          class="form-control"
                          id="state"
                          :placeholder="stateLabel"
                        />
                        <label for="state" class="control-label">
                          {{ stateLabel }}
                        </label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !addressDetail.state"
                        ></i>
                        <i class="fa fa-check" v-if="addressDetail.state"></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    name="postalcode"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group"
                      :class="{
                        errors: errors.length && !addressDetail.postalcode,
                        success: addressDetail.postalcode,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="addressDetail.postalcode"
                          class="form-control"
                          id="postalcode"
                          placeholder="Postal code / Zip code*"
                        />
                        <label for="postalcode" class="control-label">
                          Postal code / Zip code*
                        </label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !addressDetail.postalcode"
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="addressDetail.postalcode"
                        ></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    name="sourceCountry"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group form-select single-multiselect select-option-custom"
                      :class="{
                        errors: errors[0],
                        success: addressDetail.sourceCountry && !errors[0],
                      }"
                    >
                      <span class="float-label">
                        <label for="sourceCountry">Source Country*</label>
                        <multiselect
                          placeholder=""
                          v-model="addressDetail.sourceCountry"
                          :show-labels="false"
                          label="name"
                          :options="sourcecountryList"
                        >
                          <template slot="option" slot-scope="props">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  props.option.flagCode +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ props.option.name }}
                              </span>
                            </div>
                          </template>
                        </multiselect>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && errors[0]"
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="addressDetail.sourceCountry && !errors[0]"
                        ></i>
                      </span>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
              <div class="text-right">
                <a
                  href="javascript:void(0);"
                  v-if="oldAddresses.length > 0"
                  v-b-modal.oldAddress
                >
                  See Previous Addresses
                </a>
              </div>
              <div class="mb-3">
                <label class="fancy-checkbox">
                  <input
                    type="checkbox"
                    v-model="updateCheckoutAddress"
                    id="updateCheckoutAddress"
                  />
                  <span>
                    <i></i>
                    Update address to Checkout.com
                  </span>
                </label>
              </div>
              <div
                class="d-flex flex-column flex-md-row justify-content-center"
              >
                <b-button
                  variant="secondary btn-mw"
                  size="lg"
                  @click="handleCancel()"
                >
                  Cancel
                </b-button>
                <b-button
                  type="submit"
                  variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                  size="lg"
                >
                  Submit
                </b-button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </b-collapse>
    <b-modal
      id="oldAddress"
      size="lg"
      no-stacking
      no-close-on-backdrop
      hide-footer
    >
      <!-- hide-header-close -->
      <template #modal-title>
        <h5 class="text-primary font-weight-normal mb-0">Previous Addresses</h5>
      </template>
      <div class="modal-area">
        <div class="card" v-for="(data, i) in oldAddresses" :key="i">
          <span class="pl-2 font-weight-bold">
            {{ heldPeriod(data) }}
          </span>
          <div class="body row">
            <div class="col-xl-4 col-md-6 col-12">
              <ul class="list-unstyled mb-0 striped-list">
                <li>
                  <div class="row">
                    <div class="col-md-5">
                      <strong class="p-2 d-inline-block">
                        Address Line 1 :
                      </strong>
                    </div>
                    <div class="col-md-7">
                      <span class="p-2 d-inline-block">
                        {{ data?.addressline1 ? data?.addressline1 : "-" }}
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-md-5">
                      <strong class="p-2 d-inline-block">
                        Address Line 2 :
                      </strong>
                    </div>
                    <div class="col-md-7">
                      <span class="p-2 d-inline-block">
                        {{ data?.addressline2 ? data?.addressline2 : "-" }}
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-md-5">
                      <strong class="p-2 d-inline-block">Country :</strong>
                    </div>
                    <div class="col-md-7">
                      <span class="p-2 d-inline-block">
                        {{
                          data?.countryId
                            ? countryList.filter(
                                (item) => item.countryid === data?.countryId,
                              )[0].countryname
                            : "-"
                        }}
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-xl-4 col-md-6 col-12">
              <ul class="list-unstyled mb-0 striped-list">
                <li>
                  <div class="row">
                    <div class="col-md-5">
                      <strong class="p-2 d-inline-block">
                        Address Line 3 :
                      </strong>
                    </div>
                    <div class="col-md-7">
                      <span class="p-2 d-inline-block">
                        {{ data?.addressline3 ? data?.addressline3 : "-" }}
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-md-5">
                      <strong class="p-2 d-inline-block">City :</strong>
                    </div>
                    <div class="col-md-7">
                      <span class="p-2 d-inline-block">
                        {{ data?.city ? data?.city : "-" }}
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-xl-4 col-md-6 col-12">
              <ul class="list-unstyled mb-0 striped-list">
                <li>
                  <div class="row">
                    <div class="col-md-5">
                      <strong class="p-2 d-inline-block">State :</strong>
                    </div>
                    <div class="col-md-7">
                      <span class="p-2 d-inline-block">
                        {{ data?.state ? data?.state : "-" }}
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-md-5">
                      <strong class="p-2 d-inline-block">Postal Code :</strong>
                    </div>
                    <div class="col-md-7">
                      <span class="p-2 d-inline-block">
                        {{ data?.postalcode ? data?.postalcode : "-" }}
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "@/plugins/vee-validate";
import { mapGetters } from "vuex";
import { ISLOADING } from "@/store/mutations.type";
import {
  GET_CUSTOMER_ADDRESS,
  UPDATE_CUSTOMER_ADDRESS,
} from "@/store/actions.type.js";
import { myFunction } from "@/common/common-helper.js";
import { formatInUserZone } from "@/utils/datetime";
import { stateFieldFor } from "@/utils/stateField";

// To the second, not the day: correcting an address minutes after saving it is
// ordinary, and at day granularity those versions are indistinguishable.
const HELD_DATE_FORMAT = "DD-MM-YYYY h:mm:ss A";

export default {
  name: "Address",
  components: {
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
  },
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    addressDetail: {
      id: "",
      addressline1: "",
      addressline2: "",
      addressline3: "",
      state: "",
      city: "",
      postalcode: "",
      sourceCountry: "",
      loaded: false,
    },
    oldAddresses: [],
    updateCheckoutAddress: false,
  }),
  computed: {
    ...mapGetters(["countryList", "sourcecountryList"]),
    // Follows the selected country, so switching it re-labels the field and
    // toggles whether it is required.
    stateField() {
      const country = this.addressDetail.sourceCountry || {};
      return stateFieldFor(country.isocode || country.alpha2);
    },
    stateLabel() {
      return this.stateField.label + (this.stateField.required ? "*" : "");
    },
  },
  methods: {
    getaddressDetails() {
      if (this.addressDetail.loaded) {
        return;
      }
      this.fetchAddresses();
    },

    // Unguarded on purpose: the guard above belongs to the accordion header, which
    // fires on every expand. A save has to re-read regardless, because the address
    // it submitted has been superseded by a new version with a new id.
    fetchAddresses() {
      this.$store.commit(ISLOADING, true);
      this.$store
        .dispatch(GET_CUSTOMER_ADDRESS, this.customerId)
        .then((response) => {
          if (response.status == 200) {
            const address = response.data.details.filter(
              (item) => item.isActive === true,
            )[0];
            this.oldAddresses = response.data.details.filter(
              (item) => item.isActive === false,
            );
            if (address) {
              this.addressDetail = {
                id: address.addressId ? address.addressId : "",
                addressline1: address.addressline1 ? address.addressline1 : "",
                addressline2: address.addressline2 ? address.addressline2 : "",
                addressline3: address.addressline3 ? address.addressline3 : "",
                state: address.state ? address.state : "",
                city: address.city ? address.city : "",
                postalcode: address.postalcode ? address.postalcode : "",
                sourceCountry: this.countryList.filter(
                  (item) => item.countryid === address?.countryId,
                )[0],
              };
            }
          }
          this.addressDetail.loaded = true;
          this.$store.commit(ISLOADING, false);
        });
    },

    addressDataSubmit() {
      if (this.updateCheckoutAddress) {
        this.$bvModal
          .msgBoxConfirm(
            "Are you sure you want to update the card billing address for this customer?",
            {
              title: "Confirm Update",
              size: "md",
              buttonSize: "sm",
              okVariant: "primary",
              okTitle: "Yes",
              cancelTitle: "No",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            },
          )
          .then((confirmed) => {
            if (confirmed) {
              this.submitAddressUpdate();
            }
          });
      } else {
        this.submitAddressUpdate();
      }
    },

    submitAddressUpdate() {
      let params = {
        customer_id: this.customerId,
        addressline1: this.addressDetail.addressline1,
        addressline2: this.addressDetail.addressline2,
        addressline3: this.addressDetail.addressline3,
        state: this.addressDetail.state,
        city: this.addressDetail.city,
        postalcode: this.addressDetail.postalcode,
        countryId: this.addressDetail.sourceCountry.countryid,
        updateCheckoutAddress: this.updateCheckoutAddress,
      };
      if (this.addressDetail.id != "") {
        params.addressId = this.addressDetail.id;
      }
      this.$store.dispatch(UPDATE_CUSTOMER_ADDRESS, params).then((response) => {
        if (response.status == 200 || response.status == 201) {
          myFunction.showInfo(response.data.message, "success");
          this.updateCheckoutAddress = false;
          this.fetchAddresses();
        } else {
          myFunction.showInfo(response.data.message, "error");
        }
      });
    },

    // Rows that predate address versioning carry no interval, so a missing bound is
    // the normal case here and is labelled rather than left blank.
    heldPeriod(address) {
      const from = address.validFrom
        ? formatInUserZone(address.validFrom, HELD_DATE_FORMAT)
        : null;
      const to = address.validTo
        ? formatInUserZone(address.validTo, HELD_DATE_FORMAT)
        : null;

      if (from && to) return `Held ${from} to ${to}`;
      if (to) return `Held until ${to} (start not recorded)`;
      if (from) return `Held from ${from}`;
      return "Period not recorded";
    },

    handleCancel() {
      this.$router.push({ path: "/customer/list" });
    },
  },
};
</script>

<style scoped>
/* One entry per edit, so the list has to scroll inside the dialog. Not b-modal's
   `scrollable` prop: the vendored Bootstrap is 4.1.1 and has no CSS for it. The x
   axis is pinned because the cards' rows carry negative gutters that overflow
   sideways once the scrollbar takes its width. */
.modal-area {
  max-height: calc(100vh - 10rem);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
